import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      if (process.env.NODE_ENV === "development" && e.response?.status !== 401) {
        console.warn("Auth check error:", e.message);
      }
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    localStorage.setItem("pac_is_admin", "true");
    return data;
  }

  async function logout() {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      if (process.env.NODE_ENV === "development") {
        console.warn("Logout error:", e.message);
      }
    }
    localStorage.removeItem("pac_is_admin");
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
